const {apiV1WithdrawInit} = require("../../../../../api/merchant/withdraw");

module.exports = (data) => apiV1WithdrawInit({
  app_id: data.app_id,
  crypto_wallet_id: data.crypto_wallet_id,
  description: data.description
})
